// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"366b5181","180":"ed1c5b64","196":"2e7ffa8b","252":"2f9bcf5a","320":"ea5eebc0","388":"73aca8c0","444":"ca048438","472":"f69dc696","564":"ecdb90e3","580":"f19e859b","592":"fdcc153f","608":"eda6e2de","648":"a41d2b19","896":"0b03dcb4"}[chunkId] + ".chunk.js";
};